<template>
<div>
  <button v-for="(option, index) in options" @click="selected = index"
    :class="{'selected': selected === index}" :key="index">
    <input type="radio" :checked="selected === index">
    {{option}}
  </button>
</div>
</template>

<script>
export default {
  name: 'RadioButtons',
  props: {
    options: {
      type: Array,
      default: function () { return ['Yes', 'No'] }
    }
  },
  data () {
    return {
      selected: 0
    }
  }
}
</script>

<style scoped lang="scss">
button {
  font-size: 2rem;
  padding: 1rem;
  background: none;
  border: none;
  outline: none;

  &.selected {
    background: $color-yellow;
    border-radius: .5rem;
  }
}
</style>
